import React, { useState } from "react";
import Button from "../../../views/buttons/Button";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import InputTextField from "../../../views/inputfield/InputTextField";
import { RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { CATCH_MESSAGE, Logout } from "../../../UtilityFunctions";
import wbApi from "../../../API/wbApi";
import { nanoid } from "@reduxjs/toolkit";
import { updateEventsArr, updateStateAfterNewEventAdded } from "../../../redux/actions/EventsAction";
import DropzoneArea from "../../../views/customDropzone/DropzoneArea";

interface IAddEventSliderProps {
  onClose: () => void;
}

const AddEventSlider: React.FC<IAddEventSliderProps> = ({ onClose }) => {
  const { company_id, auth_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { template_id } = useSelector((state: RootState) => state.template_id);
  const { defaultSectionId } = useSelector(
    (state: RootState) => state.sections
  );

  const { property_data, current_property } = useSelector(
    (state: RootState) => state.properties
  );

  const data = useSelector(
    (state: RootState) => state.eventsSect
  );

  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [altText, setAltText] = useState("");
  const [description, setDescription] = useState<any>("");
  const [eventImageFile, setEventImageFile] = useState<any[]>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [charCount, setCharCount] = useState({
    child: 0,
    privacy: 0,
    terms_cond: 0,
    cancellation: 0,
  });

  const [update, setUpdate] = useState('')

  const dispatch = useDispatch()

  function removeTags(str: String) {
    str = str.toString();
    const finalStr = str.replace(/&nbsp;/g, " ");
    return finalStr.replace(/(<([^>]+)>)/gi, ""); // Regular expression to identify HTML tags in the input string. Replacing the identified,HTML tag with a null string.
  }
  const accpAboutFiles = (value: any) => {
    setEventImageFile(value);
  };

  const AddEventApi = async (ImgId: any) => {
    setLoader(true);
    try {
      const payload = {
        company_id,
        event_description: description,
        event_image: ImgId ?? 'undefined',
        event_image_alt: altText,
        event_title: title,
        hotel_id: data.hotel_id,
        id: 'undefined',
        template_id,
      }
      const resp = await wbApi.post(`/wb/insert-update-wb-event`, payload)

      if (resp.data.status === 1) {
        toast.success(resp.data.message)
        // dispatch(updateStateAfterNewEventAdded(nanoid()))
        const getResp = await wbApi.get(`wb-dashboard/fetch-wb-event-section-details/${company_id}/${template_id}/${defaultSectionId}`)
        dispatch(updateEventsArr(getResp.data.hotel_events))
        onClose()
        setLoader(false);
      }
      else {
        toast.error(resp.data.message);
        setLoader(false);
      }
    }
    catch {
      toast.error(CATCH_MESSAGE)
      setLoader(false);
    }
  }

  function saveHandler() {
    if (eventImageFile.length) {
      uploadHandler();
    } else {
      AddEventApi("undefined");
    }
  }

  const uploadHandler = async () => {
    if (eventImageFile.length === 1) {


      let payload = new FormData();

      payload.append("uploadFile[0]", eventImageFile[0]);
      try {
        let uploadRes = await wbApi.post(
          `/wb/insert-dz-images/${company_id}/${template_id}/hotelevent`,
          payload,
          {
            headers: {
              Authorization: "Bearer " + auth_token,
            },
          }
        );
        // console.log("uploadRes", uploadRes);
        if (uploadRes.data.status === 1) {
          await AddEventApi(uploadRes.data.image_ids);

        } else {
          toast.error(uploadRes.data.message);

        }
      } catch (error: any) {

        if (error.response.status === 401) {
          Logout();
          toast.error("Session Expired");
        } else {
          toast.error(CATCH_MESSAGE);
        }
      }

    } else {
      toast.error("Only One Image Allowed");
    }

  };



  return (
    <>
      <div className="side__slider__header__label__wrapper">
        <div className="side__slider__close">
          <i className="bi bi-x" onClick={onClose}></i>
        </div>
        <div className="standard-page--label" >Add Event</div>
      </div>

      <div className="height-64px"></div>
      <InputTextField
        label="Event Title"
        value={title}
        className="description description__slider"
        handleChange={(e) => { setTitle(e.target.value) }}
      />
      <InputTextField
        label="Alternate Text"
        value={altText}
        className="description description__slider"
        handleChange={(e) => { setAltText(e.target.value) }}
      />

      <div className="mb-2">Select Event Image</div>
      <DropzoneArea
        centerMesage={"Drag your photos or click here(1 Image Only)"}
        // incomingfiles={eventIncomingImageFile}
        dispatchFiles={(val) => accpAboutFiles(val)}
        // isDelete={(val) => delteAboutFiles(val)}
        acceptFileExt="image/jpg,image/jpeg,image/png,image/gif"
      // refresh={refreshList}
      />

      <div className="__default--input--field mt-4">
        <CKEditor
          editor={ClassicEditor}
          data={description}
          config={{
            removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed", "Table"],
          }}
          onChange={(event: string, editor: any) => {
            const data = editor.getData();
            setDescription(data);
            setCharCount({
              ...charCount,
              terms_cond: removeTags(data).length,
            });
          }}
        />
      </div>

      <div
        style={{
          width: "100%",
          height: "100px",
          backgroundColor: "white",
        }}
      ></div>

      <div className="side__slider__panel__btn">
        <div className="side__slider__panel__btn_container">
          <Button className="cancel__btn" handleClick={() => onClose()}>Cancel</Button>
          <Button handleClick={() => saveHandler()} loader={loader}>Save</Button>
        </div>
      </div>
    </>
  );
};

export default AddEventSlider;
